import productList from './productList';

export default productList;
